<template>
  <div>
    <b-card>
      <div
        v-for="station in stations"
        :id="station.CODE"
        :key="station.CODE"
        class="d-block mt-2">
        <b-btn
          :class="[station.COLLAPSED ? null : 'collapsed']"
          :aria-controls="station.CODE"
          :aria-expanded="station.COLLAPSED ? 'true' : 'false'"
          size="sm"
          @click="toggleCollapse(station.CODE)">
          <i :class="[station.COLLAPSED ? 'icon-minus' : 'icon-plus']"/>
        </b-btn>
        <h5 class="ml-2 d-inline"><span class="badge badge-success">{{ station.NAME }}</span></h5>
        <b-collapse
          :id="station.CODE"
          v-model="station.COLLAPSED">
          <CarsView
            :cars="cistByStation(station.CODE)"
            :car-in-stations="carInStations"
            :car-logs="carLogs"
            class="mt-2"/>
        </b-collapse>
      </div>
    </b-card>
  </div>
</template>
<script>
import CarsView from './CarsView'

export default {
  name: 'StationView',
  components: {
    CarsView
  },
  props: {
    carLogs: {
      type: Array,
      default: () => []
    },
    stations: {
      type: Array,
      default: () => []
    },
    zoneCode: {
      type: String,
      default: ''
    },
    carInStations: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showCollapsed: false
    }
  },
  methods: {
    cistByStation (stationCode) {
      return this.$store.getters['cleaningLogs/getCistByStation'](stationCode)
    },
    toggleCollapse(stationCode) {
      this.$store.commit('cleaningLogs/toggleStation', stationCode)
    }
  }
}
</script>
